import { binaryToHex, EcdsaSecp256k1Evm, hexToBinary } from '@streamr/utils';
import { Wallet } from 'ethers';
import { SignatureType } from '@streamr/trackerless-network';
import { KeyPairIdentity } from './KeyPairIdentity';
const signingUtil = new EcdsaSecp256k1Evm();
/**
 * An Identity that derives an Ethereum address from a secp256k1 private key
 * and uses that as the UserID instead of the actual public key.
 */
export class EthereumKeyPairIdentity extends KeyPairIdentity {
    assertValidKeyPair() {
        signingUtil.assertValidKeyPair(this.publicKey, this.privateKey);
    }
    // eslint-disable-next-line class-methods-use-this
    getSignatureType() {
        return SignatureType.ECDSA_SECP256K1_EVM;
    }
    async createMessageSignature(payload) {
        return signingUtil.createSignature(payload, this.privateKey);
    }
    async getTransactionSigner(rpcProviderSource) {
        const primaryProvider = rpcProviderSource.getProvider();
        return new Wallet(binaryToHex(this.privateKey), primaryProvider);
    }
    /** @internal */
    static fromConfig(config) {
        const privateKey = config.auth.privateKey;
        const address = config.auth.publicKey;
        return EthereumKeyPairIdentity.fromPrivateKey(privateKey, address);
    }
    static fromPrivateKey(privateKey, address) {
        return new EthereumKeyPairIdentity(hexToBinary(address ?? new Wallet(privateKey).address), hexToBinary(privateKey));
    }
    static generate() {
        const keyPair = signingUtil.generateKeyPair();
        return new EthereumKeyPairIdentity(keyPair.publicKey, keyPair.privateKey);
    }
}
//# sourceMappingURL=EthereumKeyPairIdentity.js.map